export default "__VITE_PUBLIC_ASSET__39e7e24a__"